/**
 * Below are the colors that are used in the app. The colors are defined in the light and dark mode.
 * There are many other ways to style your app. For example, [Nativewind](https://www.nativewind.dev/), [Tamagui](https://tamagui.dev/), [unistyles](https://reactnativeunistyles.vercel.app), etc.
 */

export const Spacing = {
  /** 1 */ xxxSmall: 1,
  /** 2 */ xxSmall: 2,
  /** 4 */ xSmall: 4,
  /** 6 */ offXSmall: 6,
  /** 8 */ small: 8,
  /** 10 */ offSmall: 10,
  /** 12 */ compact: 12,
  /** 14 */ offCompact: 14,
  /** 16 */ medium: 16,
  /** 18 */ offMedium: 18,
  /** 20 */ large: 20,
  /** 24 */ xLarge: 24,
  /** 32 */ xxLarge: 32,
  /** 40 */ xxxLarge: 40,
  /** 70 */ xxxxLarge: 70,
}

export const Radius = {
  /** 1 */ xxxSmall: 1,
  /** 2 */ xxSmall: 2,
  /** 4 */ xSmall: 4,
  /** 6 */ offXSmall: 6,
  /** 8 */ small: 8,
  /** 10 */ offSmall: 10,
  /** 12 */ compact: 12,
  /** 14 */ offCompact: 14,
  /** 16 */ medium: 16,
  /** 18 */ offMedium: 18,
  /** 20 */ large: 20,
  /** 24 */ xLarge: 24,
  /** 32 */ xxLarge: 32,
  /** 40 */ xxxLarge: 40,
  /** 70 */ xxxxLarge: 70,
}

export const FontFamily = "-apple-system, BlinkMacSystemFont, 'SF Pro', 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";
